import { nowPageStateParam, permissionPageInfo, PermissionItem, nowPageStateResult } from './types';
// @ts-ignore
import packageJson from '../../package.json';
import { get_ESD_indexedDB_factory } from './function';
import { IndexedDBClass } from './indexedDB';
import { ApiVersion } from '../_AAA/indexedDB_types';

// api 路徑(不包含IIS 應用程式名稱，設定寫在API_Version，透過getApiPath取得)完整路徑
let domain = window.location.origin;
// 本地開發測試的指定環境
let testDomain = packageJson.testConfig.amtestTDomain;
// 是否為本地開發測試環境
const isDev = process.env.REACT_APP_ENV === 'development';

let linkURL = window.location.origin;
let rootURL = window.location.origin;
let companyFileURL = window.location.origin + "/_" + sessionStorage.company_code;
let permisionURL = window.location.protocol + "//" + window.location.host;
let imgURL = window.location.protocol + "//" + window.location.host;
let ImportSampleURL = window.location.protocol + "//" + window.location.host + "/ImportSample";
let ExportURL = window.location.protocol + "//" + window.location.host;

if (isDev || linkURL.indexOf("localhost") !== -1) {
    console.log("開發測試環境");
    domain = testDomain;
    console.log("domain:", domain);
    rootURL = window.location.origin;
    companyFileURL = window.location.origin + "/_" + sessionStorage.company_code;
    permisionURL = process.env.PUBLIC_URL;

    linkURL = window.location.origin;
    imgURL = testDomain;
    ExportURL = testDomain;
    ImportSampleURL = testDomain + "/ImportSample";
} else if (window.location.origin.indexOf("test") !== -1) {
    domain = window.location.protocol + "//" + window.location.host;
    rootURL = window.location.protocol + "//" + window.location.host;
    companyFileURL = window.location.protocol + "//" + window.location.host + "/_" + sessionStorage.company_code;
    permisionURL = window.location.protocol + "//" + window.location.host;
    linkURL = window.location.origin;
    imgURL = window.location.protocol + "//" + window.location.host;
}

// 是不是模擬的
let is_Simulate = sessionStorage.user_simulate === "Y";

const esd_storage_raw: Storage =
    sessionStorage.getItem("user_simulate") === null
        ? localStorage
        : sessionStorage.getItem("user_simulate") === "Y"
            ? sessionStorage
            : localStorage;

const esd_storage = new Proxy(esd_storage_raw, {
    get(target: Storage, prop: string | symbol): any {
        // 保留原生方法
        if (typeof prop === "symbol" || prop in Storage.prototype) {
            const original = (target as any)[prop];
            return typeof original === "function" ? original.bind(target) : original;
        }

        const value = target.getItem(prop.toString());

        switch (value) {
            case "undefined":
                return undefined;
            case "null":
                return null;
            case "true":
                return true;
            case "false":
                return false;
            default:
                return value;
        }
    },

    set(target: Storage, prop: string | symbol, value: any): boolean {
        if (typeof prop === "symbol" || prop in Storage.prototype) {
            // 不允許覆蓋原生方法
            console.warn(`無法設定原生屬性 ${String(prop)}`);
            return false;
        }

        let valueToStore: string;

        if (value === undefined) {
            valueToStore = "undefined";
        } else if (value === null) {
            valueToStore = "null";
        } else if (typeof value === "boolean") {
            valueToStore = value ? "true" : "false";
        } else {
            valueToStore = value.toString();
        }

        target.setItem(prop.toString(), valueToStore);
        return true;
    }
});




type ApiConfig = {
    name: string;
    iisApplicationName: string;
};

/** API版本名稱列舉
 * @description 有新版本API請記得更新
 * @param DOT_NET_6 dotNet6
 * @param DOT_NET_6_AM_N dotNet6_AM_N
 * @param FRAMEWORK framework
 */
export enum ApiVersionName {
    DOT_NET_6 = 'dotNet6',
    DOT_NET_6_AM_N = 'dotNet6_AM_N',
    FRAMEWORK = 'framework'
}
export type ApiSetDetail = {
    iisApplicationName: string;
    controllers: string[];
}

// IDB存放API資訊的格式
export type ApiVersionInfo = {
    iisApplicationName: string,
    version: ApiVersionName
}

/** 把各種版本的API放這 
 * @description iisApplicationName 為 esd 才是正確 api version
 * 其他版本請改為非 "esd" 值
*/
export const API_Version: Record<string, ApiConfig> = {
    // [ApiVersionName.DOT_NET_6]: {
    //     name: ApiVersionName.DOT_NET_6,
    //     iisApplicationName: "api"
    // },
    // [ApiVersionName.FRAMEWORK]: {
    //     name: ApiVersionName.FRAMEWORK,
    //     iisApplicationName: "esd"
    // }
};

/** JSON設定取得的每間公司的API指定版本、預設版本設定的類型 */
export type ApiVersionSet = {
    defaultApiVersion: ApiVersionName,
    defaultIISApplicationName: string,
    apiDetails: Record<ApiVersionName, ApiSetDetail>
}

/** api response的資料格式 */
enum ResponseDataType {
    JSON = "application/json",
    JSONUTF8 = "application/json; charset=utf-8",
    blob = "application/pdf"
}

/** API 回傳格式 */
export type ResultObj<T = any, T2 = any> = {
    success: boolean,
    data: T,
    message: string,
    dt2?: T2 | null,
    page?: number,
    error?: T,
    title?: string,
    type?: ResponseDataType,
    status?: Response['status']
    exportPath?: string
};

/** request data type */
type RequestObj = { [key: string]: any } | FormData;

/** 取得該controller的指定API版本 
 * @author Daniel Wang
 * @description 取得不到的時候會回傳json的預設API版本defaultApiVersion
 * 並且將取得到的json設定的預設API版本放到localStorage
 * 會先嘗試從IndexDB取得，如果沒有猜去get請求
 * 
 * 嘗試從idb取得指定的controller的apiVersion
 * 如果任何原因找不到，就發出get請求取得api_version.json
 * 取得之後把拿到的版本號放到IDB
 * 
 * @param controller_name 
 * @returns apiVersion :string | null
 * 拿到null原因
 * 1. 沒有(或是不正確的)company_code
 * 2. 沒有api_version.json
 * 
 * apiVersion 取得優先度
 * 1. idb 中以儲存資料
 * 2. 對應公司資料夾內 api_version.json 設定檔 (若有找到則設定進 idb )
 */
export const getControllerApiVersion = async (controller_name: string): Promise<ApiVersionInfo | null> => {
    let company_code: string | null = sessionStorage.getItem("company_code");
    let apiVersion: ApiVersionInfo | null = null;

    return await get_ESD_indexedDB_factory()
        .then(async (idb: (IndexedDBClass | null)) => {
            if (!!company_code) {
                // 查 IDB 內 API version 
                if (idb !== null) {
                    await idb.search<ApiVersion<ApiVersionInfo>>("ApiVersion", [company_code!, controller_name])
                        .then((res: ResultObj<ApiVersion<ApiVersionInfo>>) => {
                            apiVersion = res.success && res.data !== null ? res.data.data : null;
                        }).catch(e => {
                            console.error("idb 查詢失敗", [company_code!, controller_name], e);
                            apiVersion = null;
                        });
                }

                if (apiVersion === null) {
                    try {
                        let api_version_set: ApiVersionSet | null = await getApiVersionJSON();

                        if (api_version_set === null)
                            throw new Error(`${permisionURL}/_${company_code}/api_version.json?x=` + Date.now() + "取得失敗");

                        localStorage.setItem("defaultApiVersion", api_version_set.defaultApiVersion);
                        for (let version in api_version_set.apiDetails) {
                            if (api_version_set.apiDetails[version as ApiVersionName].controllers.some(item => item === controller_name)) {
                                apiVersion = {
                                    iisApplicationName: api_version_set.apiDetails[version as ApiVersionName].iisApplicationName,
                                    version: version as ApiVersionName
                                };
                            }
                        }

                        if (apiVersion === null) {
                            apiVersion = {
                                iisApplicationName: api_version_set.apiDetails[api_version_set.defaultApiVersion as ApiVersionName].iisApplicationName,
                                version: api_version_set.defaultApiVersion as ApiVersionName
                            };;
                        }

                        if (idb !== null)
                            await idb.update<ApiVersion<ApiVersionInfo>>("ApiVersion", {
                                company_code: company_code,
                                api_controller_name: controller_name,
                                data: {
                                    iisApplicationName: apiVersion.iisApplicationName,
                                    version: apiVersion.version
                                }
                            });

                        return apiVersion;
                    } catch {
                        console.error("沒有公司客製化API版本設定json");
                        return null;
                    }
                } else return apiVersion;
            } else {
                console.warn("還沒有公司代碼，遞迴嘗試呼叫各版本API");
                return null;
            }
        });
}

/** 檢查現在登入的是不是admin
 * @returns {boolean}
 */
export const is_Admin = (): boolean => esd_storage.getItem("name")?.toString() === "admin";

/** 帳號是否是經銷商&權限
 * @returns company_code === company_code_head: 總公司
 * @returns company_code !== company_code_head: 經銷商
 */
export const NotDealerPermisionView = (ds_id: string): boolean => {
    let check = true
    if (ds_id === "undefined" || ds_id === "" || ds_id === undefined) return check = false;
    const isDealer = JSON.parse(sessionStorage.isDealer.toLowerCase())

    if (ds_id) {
        if (ds_id.toString() === sessionStorage.ds_id
            && isDealer) {
            check = false;
        } else {
            if (ds_id.toString() === sessionStorage.ds_id
                && !isDealer) {
                check = false;
            } else {
                check = true;
            }
        }
    }
    return check;
}

/** 判斷是不是總公司 */
export const isCompanyHead = (): boolean => {
    let company_code: string | null = sessionStorage.getItem("company_code");
    let company_code_head: string | null = sessionStorage.getItem("company_code_head");
    if (company_code === null || company_code_head === null) return false;
    else return company_code.toString().toLowerCase() === company_code_head.toString().toLowerCase();
}

/** doFetch
 * @param {string} apiPath api 路徑
 * @param {string} uri api controller/api name
 * @param {string} obj formData/欲放資料
 * @param {string} needToken 需不需要 token
 * @param {string} lowestPriorityApiVersion 最低優先度 apiVersion (表示先前無可使用紀錄 api 版本)
 * @param {AbortController} abortController AbortController 接口, 用於註冊api signal 以便執行取消請求
 * @param {string} fetchType "POST" | "GET" , 預設 "POST"
 */
const doFetch = async <T = RequestObj>(apiPath: string, uri: string, obj?: T, needToken?: boolean, lowestPriorityApiVersion?: ApiVersionName, abortController?: AbortController, fetchType: 'POST' | 'GET' = 'POST'): Promise<ResultObj> => {
    try {
        const isFormData = obj instanceof FormData;
        const headers =
            (isFormData ?
                {
                    'Authorization': `Bearer ${esd_storage.token ?? ''}`
                } :
                {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': `Bearer ${esd_storage.token ?? ''}`
                }) as any;
        // 如果不需要token
        if (needToken === false) delete headers.Authorization;
        const response = await fetch(`${apiPath}${uri}`, {
            method: fetchType,
            headers: headers,
            body: fetchType === "POST" ? isFormData ? obj : JSON.stringify(obj ?? {}) : undefined,
            // 註冊 AbortSignal 
            signal: abortController ? abortController.signal : undefined
        }).then(async (res) => {
            // 若先前無已確定可使用 Api Version, 將狀態為 200 成功之apiVersion存進 localStorage
            if (!!lowestPriorityApiVersion && res.status === 200) {
                localStorage.setItem('defaultApiVersion', lowestPriorityApiVersion);
            }
            // 判斷回傳 Content type
            if (res.headers.get("Content-type") === ResponseDataType.JSON || res.headers.get("Content-type") === ResponseDataType.JSONUTF8) {
                if (!res.ok) {
                    return res.json().then(errorData => {
                        throw errorData;
                    });
                }
                return { type: "json", ...await res.json(), status: res.status };
            } else if (res.headers.get("Content-type") === ResponseDataType.blob) {
                return {
                    type: "blob",
                    success: res.headers.get("success"),
                    message: res.headers.get("message"),
                    data: await res.blob().then(async (myBlob: Blob) => URL.createObjectURL(myBlob)),
                    status: res.status
                }
            } else {
                console.warn("出現例外回傳資料型態");
                if (res.status === 404) {
                    return { type: "other", success: false, message: 'api 路徑 404 ', data: res, status: res.status };
                } else if (res.status === 400) {
                    const errorData = await res.json();
                    const formattedErrors = errorData.errors
                        ? Object.entries(errorData.errors)
                            .filter(([key]) => key !== 'data')
                            .map(([key, values]) => `${key}: ${Array.isArray(values) ? values.join(', ') : values}`)
                            .join('、')
                        : '請求錯誤 (400)';
                    return {
                        type: "other",
                        success: false,
                        message: formattedErrors || errorData.message || '請求錯誤',
                        data: errorData,
                        status: res.status
                    };
                } else {
                    return { type: "other", ...await res.json(), status: res.status };
                }
            }
        }).catch(error => ({
            success: false,
            message: error.title ?
                error.title
                : error.name === 'AbortError'
                    ? "已取消執行"
                    : "API: " + apiPath + "/" + uri + " response error." + (error.status ? "status:" + error.status : ""),
            data: error.errors,
        }));
        return response;
    } catch (error) {
        console.error(error);
        return { success: false, message: "api is fail to fetch", data: null };
    }
};

/** 取得 API 的路徑
 * @author Daniel Wang
 * @description 因為有可能有不同版本的API存在所以別的地方要使用API路徑，一定要經過這個function拿取正確的路徑，或是指定的API版本的路徑
 * @description 先判斷有沒有指定類型，沒有的話就從api_version.json取得預設iisApplicationName
 * @param version 指定的API版本
 * @returns 
 */
const getAPIPath = async (api_version_set?: ApiVersionInfo): Promise<string | null> => {
    if (!!api_version_set) return domain + "/" + api_version_set.iisApplicationName + "/";
    else {
        let company_code: string | null = sessionStorage.getItem("company_code");
        if (company_code !== null) {
            let api_version_set: ApiVersionSet | null = await getApiVersionJSON();
            if (api_version_set === null)
                throw new Error(`${permisionURL}/_${company_code}/api_version.json?x=` + Date.now() + "取得失敗");
            return domain + "/" + api_version_set.defaultIISApplicationName + "/";
        } else {
            throw new Error("遺失公司代碼 sessionStorage.company_code");
        }
    }
}

/** 取得公司的api JSON設定 */
const getApiVersionJSON = async (company_code?: string): Promise<ApiVersionSet | null> =>
    company_code ?
        await fetch(`${permisionURL}/_${company_code}/api_version.json?x=` + Date.now()).then(r => r.json()).catch(e => null) :
        sessionStorage.getItem("company_code") ?
            await fetch(`${permisionURL}/_${sessionStorage.getItem("company_code")}/api_version.json?x=` + Date.now()).then(r => r.json()).catch(e => null) :
            await fetch(`${permisionURL}/login_api_version.json?x=` + Date.now()).then(r => r.json()).catch(e => null);

/** call api (需要 token)
 * @param uri api controller/api name
 * @param obj formData/欲放資料
 * @param apiVersion api 版本
 * @param abortController AbortController 接口, 用於註冊api signal 以便執行取消請求
 * @param {string} fetchType "POST" | "GET" , 預設 "POST"
 * @description 若用"GET" 請自行把參數填好於 uri 中
 * @description api 版本 取得優先度
 * 1. 丟入的 apiVersion 參數
 * 2. idb 已儲存版本 (來自先前已 call 過結果)
 * 3. 對應公司資料夾內 api_version.json 設定檔 (若有找到則設定進 idb )
 * 4. 由 domain(window.location.origin) 嘗試現有 api 版本嘗試最終結果
 */
export const allFetch = async <T = RequestObj>(uri: string = "", obj?: T, apiVersion?: ApiVersionName, abortController?: AbortController, fetchType: 'POST' | 'GET' = 'POST'): Promise<ResultObj> => {
    uri = uri.substring(0, 1) === "/" ? uri.substring(1, uri.length) : uri;
    // 如果已經有公司名稱了，就找到該api有沒有在json裡面指定他的API版本，如果有就拿來當作apiVersion丟去產生路徑
    let controller = uri.split("/")[0];
    let getAPIversionResult = await getControllerApiVersion(controller);
    apiVersion = getAPIversionResult === null ? apiVersion : getAPIversionResult.version;

    let domainStr: string | null = getAPIversionResult === null ? null : await getAPIPath(getAPIversionResult);
    if (domainStr !== null) {
        let result = await doFetch<T>(domainStr, uri, obj, undefined, undefined, abortController, fetchType);
        return result;
    }
    else {
        /** 最終成功後之結果 */
        let finalResult: ResultObj | null = null

        let api_sets: ApiVersionSet | null = await getApiVersionJSON();
        if (api_sets !== null) {
            for (let version in api_sets.apiDetails) {
                domainStr = domain + "/" + api_sets.apiDetails[version as ApiVersionName].iisApplicationName + "/";
                const result: ResultObj = await doFetch<T>(domainStr, uri, obj, undefined, version as ApiVersionName, abortController, fetchType);
                // 若 API有成功(status 200)
                if (finalResult === null && result.status && result.status === 200) {
                    finalResult = result;
                    break;
                }
            }
        } else {
            throw new Error("getApiVersionJSON 無法取得api_version.json");
        }
        return finalResult || { success: false, message: "沒有正確的API版本存在", data: null };
    }
}
/**
 * @description 在allFetch()外多包一層判斷，賦予allFetch()自動將success：false的結果丟出錯誤的功能，目前只用於adapter上
 * @warning 這個function會自動丟出錯誤，請務必在try catch中使用,否則會導致整個程式會被中斷
 */
export const autoThrowErrorFetch = async <T = RequestObj>(uri: string = "", obj?: T, apiVersion?: ApiVersionName, abortController?: AbortController, fetchType: 'POST' | 'GET' = 'POST'): Promise<ResultObj> => {
    const resObj = await allFetch<T>(uri, obj, apiVersion, abortController, fetchType);
    if (!resObj.success) {
        throw resObj
    }
    return resObj;
}

// TODO 暫時先這樣處理不需要token的呼叫API方式
/** call api (不需要 token)
 * @param uri api controller/api name
 * @param obj formData/欲放資料
 * @param apiVersion api 版本
 * api 版本 取得優先度
 * 1. 丟入的 apiVersion 參數
 * 2. idb 已儲存版本 (來自先前已 call 過結果)
 * 3. 對應公司資料夾內 api_version.json 設定檔 (若有找到則設定進 idb )
 * 4. 由 domain(window.location.origin) 嘗試現有 api 版本嘗試最終結果
 */
export const allFetchNoToken = async <T = RequestObj>(uri: string = "", obj?: T, apiVersionInfo?: ApiVersionInfo): Promise<ResultObj> => {
    uri = uri.substring(0, 1) === "/" ? uri.substring(1, uri.length) : uri;
    // 如果已經有公司名稱了，就找到該api有沒有在json裡面指定他的API版本，如果有就拿來當作apiVersion丟去產生路徑
    let controller = uri.split("/")[0];
    let getAPIversionResult = await getControllerApiVersion(controller);
    //apiVersion = getAPIversionResult === null ? apiVersion : getAPIversionResult.version;
    const finalApiVersion = apiVersionInfo || getAPIversionResult || undefined;

    //let domainStr: string | null = getAPIversionResult === null ? null : await getAPIPath(getAPIversionResult);

    let domainStr: string | null = finalApiVersion ? await getAPIPath(finalApiVersion) : null;

    if (domainStr !== null) return await doFetch<T>(domainStr, uri, obj, false);
    else {
        /** 最終成功後之結果 */
        let finalResult: ResultObj | null = null

        let api_sets: ApiVersionSet | null = await getApiVersionJSON();
        if (api_sets !== null) {
            for (let version in api_sets.apiDetails) {
                domainStr = domain + "/" + api_sets.apiDetails[version as ApiVersionName].iisApplicationName + "/";
                const result: ResultObj = await doFetch<T>(domainStr, uri, obj, undefined, version as ApiVersionName);
                // 若 API有成功(status 200)
                if (finalResult === null && result.status && result.status === 200) {
                    finalResult = result;
                    break;
                }
            }
        } else {
            throw new Error("getApiVersionJSON 無法取得api_version.json");
        }
        return finalResult || { success: false, message: "沒有正確的API版本存在", data: null };
    }
}

// check sign
export const checkSign = async (): Promise<ResultObj> => {
    let res = await allFetch('usercontrol/check');
    if (res.success) {
        const companyCode = (res.data as any)?.company_code ?? '';
        const companyCodeHead =
            (res.data as any)?.company_code_head ??
            (res.data as any)?.companyCodeHead ??
            companyCode;

        if (is_Simulate) sessionStorage.token = res.data.token;
        else localStorage.token = res.data.token;

        esd_storage.token = res.data.token;
        sessionStorage.Plant = res.data.Plant;
        sessionStorage.company_code = companyCode;
        sessionStorage.company_code_head = companyCodeHead;
        sessionStorage.isDealer = !!companyCode && !!companyCodeHead ? (companyCode !== companyCodeHead) : false;

        localStorage.company_code = companyCode;
        localStorage.company_code_head = companyCodeHead;
        localStorage.isDealer = !!companyCode && !!companyCodeHead ? (companyCode !== companyCodeHead) : false;
    } else {
        alert("帳號已登出，請重新登入。msg:" + res.message);
        await signout();
    }
    return res;
}

// signout
export const signout = async (): Promise<ResultObj> => {
    return await allFetch('usercontrol/signout');
}

// get permision
export const getPermision = async (path: string): Promise<PermissionItem> => {
    let hp = sessionStorage.home_page;
    // 暫時用此方法代替
    let response: Array<any> = await fetch(`${permisionURL}/_${sessionStorage.company_code}/Users/${path}/permission.json?x=` + Date.now())
        .then(r => r.json());

    const res: PermissionItem = {
        items: await response,
        sidebar: null,
        nav: null
    };

    if (res.items) {
        if (response.length > 0) {
            if (!response.some(i => i.name === hp)) hp = response[0].name;
            res.sidebar = await response
                .find(i => i.name === hp)
                .children.find((ci: permissionPageInfo) => ci.name === 'sidebar');

            res.nav = await response
                .find(i => i.name === hp)
                .children.find((ci: permissionPageInfo) => ci.name === 'nav');
        } else {
            console.log('無權限', res); // 這邊要導回 無權限頁面
            alert("無權限使用");
            return res;
        }
    } else {
        console.log('請聯絡開發者', res); // 這邊要導回 無權限頁面
        return res;
    }
    return res;
};

//檢查頁面群組及頁面的權限
export const nowPageState = async (obj: nowPageStateParam): Promise<nowPageStateResult> => {
    let groupArr: permissionPageInfo[] = obj.sidebar === null ? [] : obj.sidebar.children.filter(i => i.code === obj.groupCode);
    let groupY = groupArr.length > 0 ? true : false;
    let pageArr = groupY ? groupArr[0].children.filter(i => i.code === obj.pageCode) : [];
    let pageY = pageArr.length > 0 ? (pageArr[0].code === obj.pageCode ? true : false) : false;
    return {
        groupArr: groupArr,
        groupY: groupY,
        pageArr: pageArr,
        pageY: pageY
    };
}

// 檢查按鈕的權限
export const btnState = (btnId: string, Arr: nowPageStateResult, pageName: string = ''): boolean => {
    if (Arr.pageArr.length > 0) {
        return Arr.pageArr[0].children.some(i => i.ctrl_code === btnId);
    } else if (Arr.groupArr.length > 0) {
        let pageArr = Arr.groupArr[0].children;
        if (pageName)
            pageArr = pageArr.filter(j => j.code === pageName);
        if (pageArr.length > 0)
            return pageArr[0].children.some(i => i.ctrl_code === btnId);
    }
    return false;
}

export { permisionURL, imgURL, ImportSampleURL, ExportURL, esd_storage, linkURL, getAPIPath, getApiVersionJSON };
